// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
production: false,
//   //webApiURL: 'https://webapi-ollerup.azurewebsites.net/'
webApiURL: 'https://dev-webapi.ollerup.dk/',
tokenURL: 'https://dev-webapi.ollerup.dk/token'
// production: true,
// webApiURL: 'https://webapi.ollerup.dk/',
// tokenURL: 'https://webapi.ollerup.dk/token'
};
